// authStorage.js
/*
    메모리 기반 토큰 저장소
    메모리 값이 변경되면 useSyncExternalStore 구독자들에게 알림
    구독자들은 변경을 감지해서 값을 다시 가져옴
*/
export let memoryAccessToken = null
const memoryAccessTokenListeners = new Set();

export function setMemoryAccessToken(newToken) {
    memoryAccessToken = newToken;
    memoryAccessTokenListeners.forEach(listener => listener());
}

export function getMemoryAccessToken() {
    return memoryAccessToken
}

export function clearMemoryAccessToken() {
    setMemoryAccessToken(null);
}

export function subscribeMemoryAccessToken(onChange) {
    memoryAccessTokenListeners.add(onChange);
    return () => {
        memoryAccessTokenListeners.delete(onChange);
    };
}

/*
// 값을 가져와서 사용할때 사용하는 예시
import { useSyncExternalStore } from "react";

const value = useSyncExternalStore(
    subscribeMemoryAccessToken,  // 구독 함수
    getMemoryAccessToken,   // 값 가져오는 함수
    () => memoryAccessToken // 서버 스냅샷 함수 (SSR 시)
);
*/